import { Editor } from "@tinymce/tinymce-react";
import { openOrCloseModalSnippets } from "../../../../../../hooks/automation";
import { connect, useSelector } from "react-redux";

const RichTextEditor = ({ onChange, value, onBlur, fieldName, fieldLabel, onOpenOrCloseModalSnippets }) => {
    const { isDarkMode } = useSelector((state) => state.theme);

    const handleEditorChange = (content, editor) => {
        if (onChange) {
            console.log(content)
            onChange(content);
        }
    };

    const handleBlur = (event, editor) => {
        if (onBlur) {
            onBlur(event);
        }
    };

    return (
        <>
            {/* key: o TinyMCE só lê skin/content_css no init — remonta ao trocar o tema */}
            <Editor
                key={isDarkMode ? "dark" : "light"}
                value={value ?? ""}
                init={{
                    license_key: "gpl",
                    language: 'pt_BR',
                    selector: 'textarea',
                    plugins: [
                        'lists',
                        'link',
                        'image',
                        'table',
                        'code',
                        'autoresize',
                        'fullscreen',
                        'preview',
                        'emoticons',
                        'charmap',
                        'advlist'
                    ],
                    toolbar: 'snippet_editor | undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code fullscreen preview',
                    skin_url: isDarkMode ? '/tinymce/skins/ui/oxide-dark' : '/tinymce/skins/ui/oxide',
                    content_css: isDarkMode
                        ? '/tinymce/skins/content/dark/content.min.css'
                        : '/tinymce/skins/content/default/content.min.css',
                    base_url: '/tinymce',
                    setup: (editor) => {
                        editor.ui.registry.addButton('snippet_editor', {
                            text: 'Abrir editor avançado',
                            onAction: () => {
                                onOpenOrCloseModalSnippets({ action: true, fieldName, fieldLabel })
                            }
                        });
                    },
                    entity_encoding: 'raw',
                }}
                tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                onEditorChange={handleEditorChange} // Função para lidar com alterações no conteúdo do editor
                onBlur={handleBlur}
            />
        </>
    )
}
const mapDispatchToProps = (dispatch) => {
    return {
        onOpenOrCloseModalSnippets: ({ action, fieldName, fieldLabel }) => dispatch(openOrCloseModalSnippets({
            action,
            fieldName,
            fieldLabel,
        })),
    };
};

export default connect(null, mapDispatchToProps)(RichTextEditor)
